import { DEFAULT_DATE_FORMAT, DEFAULT_TIME_FORMAT } from '@shared/utils'
import { Flex, FlexProps } from 'antd'
import dayjs from 'dayjs'

import { Text, TextProps } from '../Text'

import { useStyles } from './styles'

type Props = {
  date: dayjs.ConfigType
  dateFormat?: string
  timeFormat?: string
  hiddenTime?: boolean
  dateProps?: TextProps
  timeProps?: TextProps
} & Omit<FlexProps, 'children'>

export const DateTimeCell = ({
  date,
  dateFormat = DEFAULT_DATE_FORMAT,
  timeFormat = DEFAULT_TIME_FORMAT,
  hiddenTime,
  dateProps,
  timeProps,
  ...props
}: Props) => {
  const { styles, cx } = useStyles()

  if (!date) return '-'

  const formatDate = dayjs(date).format(dateFormat)
  const formatTime = dayjs(date).format(timeFormat)

  return (
    <Flex gap={4} {...props}>
      <Text
        {...dateProps}
        className={cx(styles.dateTimeText, dateProps?.className)}
      >
        {formatDate}
      </Text>
      {!hiddenTime && (
        <Text
          {...timeProps}
          className={cx(styles.dateTimeTextSecondary, timeProps?.className)}
        >
          {formatTime}
        </Text>
      )}
    </Flex>
  )
}
